import { BidiModule } from "@angular/cdk/bidi";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { UiIconModule } from "../icon/icon.module";
import { UiCheckboxComponent } from "./checkbox.component";
import { UiCheckboxGroupComponent } from "./components/checkbox-group/checkbox-group.component";
import { UiCheckboxWrapperComponent } from "./components/checkbox-wrapper/checkbox-wrapper.component";

@NgModule({
  imports: [CommonModule, BidiModule, FormsModule, UiIconModule],
  declarations: [UiCheckboxComponent, UiCheckboxWrapperComponent, UiCheckboxGroupComponent],
  exports: [UiCheckboxComponent, UiCheckboxWrapperComponent, UiCheckboxGroupComponent],
})
export class UiCheckboxModule {}
